var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticStyle:{"padding":"30px"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h1',[_vm._v("Logging out...")]),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }